import * as Yup from 'yup'
import { formatNumber } from '../../../../helpers/numbers'

interface GetImpressionsValidationParams {
  remainingImpressions: number
  initialImpressions?: number
  calculatedImpressions?: number
  requiredMessage?: string
}

export const getImpressionsValidation = ({
  remainingImpressions,
  initialImpressions,
  calculatedImpressions,
  requiredMessage = 'Impression Required'
}: GetImpressionsValidationParams): Yup.NumberSchema => {
  // In edit form we need to sum: remainingImpressions + initialImpressions, to represent the max value user can enter
  const maxImpression = initialImpressions ? remainingImpressions + initialImpressions : remainingImpressions

  if (calculatedImpressions) {
    return Yup.number()
      .min(calculatedImpressions, `You must enter at least ${formatNumber(calculatedImpressions)} impressions.`)
      .max(maxImpression, `The maximum number of impressions you can enter is ${formatNumber(maxImpression)}`)
      .required(requiredMessage)
  } else {
    return Yup.number()
      .max(maxImpression, `The maximum number of impressions you can enter is ${formatNumber(maxImpression)}`)
      .required(requiredMessage)
  }
}
